<script>
  import Markdown from "svelte-exmarkdown";
  import { onMount } from "svelte";
  import Template from "./app/AppTemplate.svelte";
  import * as Sidebar from "$lib/components/ui/sidebar/index.js";

  let documents = $state({});
  let filenames = $state([]);
  let currentFilename = $state("");

  onMount(async () => {
    const modules = import.meta.glob("../../docs/*/*.md", {
      query: "?raw",
      import: "default",
    });
    const newDocuments = {};
    for (const path in modules) {
      const contents = await modules[path]();
      const filename = path
        .split("/")
        .pop()
        .split("-")
        .splice(1)
        .join("-")
        .replace(".md", "");
      const title = filename.replaceAll("_", " ").replaceAll("-", " ");
      newDocuments[filename] = { contents, path, filename, title };
    }
    documents = { ...newDocuments };
    console.log($state.snapshot(documents));
    filenames = Object.values(documents)
      .sort((a, b) => a.path.localeCompare(b.path))
      .map((x) => x.filename);
    if (filenames.length > 0) {
      currentFilename = filenames[0];
    }
  });
</script>

<Template text={true}>
  {#snippet sidebar(sidebar)}
    <Sidebar.Menu>
      {#each filenames as filename}
        {@const { title } = documents[filename]}
        <Sidebar.MenuItem>
          <Sidebar.MenuButton
            isActive={filename === currentFilename}
            onclick={() => (currentFilename = filename)}
          >
            {#snippet child({ props })}
              <a href={`#${filename}`} {...props}>
                <span class="capitalize">{title}</span>
              </a>
            {/snippet}
          </Sidebar.MenuButton>
        </Sidebar.MenuItem>
      {/each}
    </Sidebar.Menu>
  {/snippet}
  {#if currentFilename}
    <Markdown md={documents[currentFilename].contents} />
  {/if}
</Template>
